(() => {
  const ARL = window.ARLISHCO;
  if (!ARL) return;

  function createSavedProductCard(product) {
    const article = document.createElement('article');
    article.className = 'arl-saved-card arl-reveal is-visible';
    const mediaLink = document.createElement('a');
    mediaLink.className = 'arl-saved-card__media';
    mediaLink.href = product.url || `${ARL.storefrontRoot()}products/${product.handle}`;
    if (product.featured_image) {
      const image = document.createElement('img');
      image.src = product.featured_image; image.alt = product.title || 'Saved product';
      image.loading = 'lazy'; image.width = 800; image.height = 800; mediaLink.append(image);
    } else {
      const placeholder = document.createElement('span'); placeholder.className = 'arl-saved-card__placeholder';
      placeholder.textContent = 'ARLISHCO'; mediaLink.append(placeholder);
    }
    const body = document.createElement('div'); body.className = 'arl-saved-card__body';
    const status = document.createElement('p');
    status.className = `arl-saved-card__status${product.available ? '' : ' is-unavailable'}`;
    status.textContent = product.available ? 'Available' : 'Currently unavailable';
    const heading = document.createElement('h2');
    const productLink = document.createElement('a'); productLink.href = mediaLink.href; productLink.textContent = product.title || 'Product';
    heading.append(productLink);
    const price = document.createElement('p'); price.className = 'arl-saved-card__price';
    price.textContent = ARL.formatCartMoney(Number(product.price) || 0);
    if (Number(product.compare_at_price) > Number(product.price)) {
      const compare = document.createElement('s'); compare.textContent = ARL.formatCartMoney(Number(product.compare_at_price)); price.append(compare);
    }
    const actions = document.createElement('div'); actions.className = 'arl-saved-card__actions';
    const variant = (product.variants || []).find((item) => item.available);
    const addButton = document.createElement('button'); addButton.type = 'button'; addButton.className = 'button';
    addButton.textContent = variant ? 'Add to cart' : 'Unavailable'; addButton.disabled = !variant;
    if (variant) addButton.addEventListener('click', () => ARL.addVariantToCart(variant.id, addButton));
    const removeButton = document.createElement('button'); removeButton.type = 'button'; removeButton.className = 'arl-saved-card__remove';
    removeButton.textContent = 'Remove'; removeButton.addEventListener('click', () => ARL.toggleWishlist(product.handle, product.title));
    actions.append(addButton, removeButton); body.append(status, heading, price, actions); article.append(mediaLink, body);
    return article;
  }

  async function renderWishlistPage(force = false) {
    const page = document.querySelector('[data-arl-wishlist-page]');
    if (!page || page.dataset.arlRendering === 'true') return;
    const grid = page.querySelector('[data-arl-wishlist-grid]');
    const empty = page.querySelector('[data-arl-wishlist-empty]');
    const loading = page.querySelector('[data-arl-wishlist-loading]');
    if (!grid || !empty || !loading) return;
    const handles = ARL.readWishlist();
    const signature = handles.join('|');
    if (!force && page.dataset.arlWishlistSignature === signature) return;
    page.dataset.arlRendering = 'true'; page.dataset.arlWishlistSignature = signature;
    grid.replaceChildren(); empty.hidden = true; loading.hidden = handles.length === 0;
    if (!handles.length) { empty.hidden = false; page.dataset.arlRendering = 'false'; return; }
    try {
      const results = await Promise.allSettled(handles.map(ARL.fetchStorefrontProduct));
      const products = results.filter((result) => result.status === 'fulfilled').map((result) => result.value);
      const validHandles = products.map((product) => product.handle);
      if (validHandles.length !== handles.length) { ARL.writeWishlist(validHandles); page.dataset.arlWishlistSignature = validHandles.join('|'); }
      products.forEach((product) => grid.append(createSavedProductCard(product)));
      loading.hidden = true; empty.hidden = products.length > 0; ARL.updateWishlistInterface();
    } finally { page.dataset.arlRendering = 'false'; }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => renderWishlistPage(), { once: true });
  else renderWishlistPage();
  document.addEventListener('arl:wishlist-change', () => renderWishlistPage(true));
  document.addEventListener('shopify:section:load', () => renderWishlistPage(true));
})();
